// delReportingTab/actions.js

import { delReportingTabUIInitialState } from "./uiLandingPageDelReportingTabState";

export const makeDelReportingTabUIActions = (set, get) => ({
  setShowDelForm: (show) =>
    set((s) => ({
      delReportingTabUI: { ...s.delReportingTabUI, showDelForm: !!show },
    })),
  resetDelReportingTabUI: () =>
    set({ delReportingTabUI: delReportingTabUIInitialState }),
});
